"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailureModeCases = void 0;
const effect_1 = require("effect");
exports.FailureModeCases = effect_1.Data.taggedEnum();
//# sourceMappingURL=failure-mode.js.map